import React, { useState, useRef, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import Company from "../components/company";
import { fetchItemsFromServer } from "./reviewLists"; 
import starofcat from '../assets/starofcat.svg';
import finalcheck from '../assets/finalcheck.svg';
import '../app.css';
import { Helmet } from "react-helmet-async";

function CategoriesPage() {
  const { categoryName } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const itemsContainerRef = useRef(null);

  // --- PERSISTENCE LOGIC: Initialize state from URL or defaults ---
  const [selectedCountry, setSelectedCountry] = useState(searchParams.get("country") || "United Kingdom");
  const [minRating, setMinRating] = useState(parseFloat(searchParams.get("rating")) || 0);
  
  const [FilteredItems, setFilteredItems] = useState([]);
  const [totalServerCount, setTotalServerCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const itemsPerPage = 10;

  const currentPage = parseInt(searchParams.get("page")) || 1;
  const prevFiltersRef = useRef({ categoryName, selectedCountry, minRating });

  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  };

  const handleSetPage = (pageNumber) => {
    const totalPages = Math.ceil(totalServerCount / itemsPerPage) || 1;
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      // Keep existing country/rating when changing page
      setSearchParams({ 
        country: selectedCountry, 
        rating: minRating, 
        page: pageNumber 
      });
      scrollToTop();
    }
  };

  // Update URL whenever Country or Rating changes
  const handleFilterChange = (newCountry, newRating) => {
    setSelectedCountry(newCountry);
    setMinRating(newRating);
    setSearchParams({ 
      country: newCountry, 
      rating: newRating, 
      page: 1 
    });
  };

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        const { data, totalCount } = await fetchItemsFromServer({
          categoryName,
          page: currentPage,
          pageSize: itemsPerPage,
          country: selectedCountry,
          minRating: minRating
        });

        setFilteredItems(data);
        setTotalServerCount(totalCount);

        const filtersChanged = 
          prevFiltersRef.current.categoryName !== categoryName ||
          prevFiltersRef.current.selectedCountry !== selectedCountry ||
          prevFiltersRef.current.minRating !== minRating;

        if (filtersChanged) {
          // Logic handled by handleFilterChange, but safety check here
          scrollToTop();
          prevFiltersRef.current = { categoryName, selectedCountry, minRating };
        }
      } catch (error) {
        console.error("Fetch Error:", error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [categoryName, currentPage, selectedCountry, minRating]);

  const countries = [
    "All Countries", "Switzerland", "France", "Italy", "United Kingdom", 
    "United States", "Germany", "Portugal", "Spain", "Sweden", "Belgium",
    "Norway", "Poland", "Czech Republic", "Croatia", "Austria", "Denmark",
    "Finland", "Latvia", "Australia", "Netherlands", "Egypt", "Cameroon",
    "Canada", "Brazil", "Argentina", "China", "Japan", "Colombia"
  ];

  const totalLoopPages = Math.ceil(totalServerCount / itemsPerPage) || 1;

  

  return (
    <div className="bg-[#f3f3f3] lg:min-h-[1300px] xs:flex xs:flex-col pt-0 ">
      <Helmet>
  <title>Sitemanifest</title> {/* e.g., Login or Dashboard */}
  
  {/* The directive to stay out of search results */}
  <meta name="robots" content="noindex, nofollow" />
  
  {/* Prevent search engines from showing a "cached" version of a private dashboard */}
  <meta name="googlebot" content="noarchive" />
</Helmet>
      <div className="flex flex-col xs:w-full relative bg-white ">
        <div className=" bg-[#1E7D6B] 2xl:mx-auto pb-[40px] w-full ">
          <div className="hidden 2xl:flex pt-[50px] lg:pt-[85px] w-full max-w-[1440px] mx-auto">
             <div className="font-poppins text-white xl:text-[14px] font-light flex xl:px-[64px] font-regular text-[10px] lg:text-[12px] lg:pt-[24px] pt-[12px] xs:px-[32px] px-[16px]">
              <a href={"/"}><span className="mr-[7px]">Category</span></a>
              <div className="mr-[7px] mt-[0px]">&gt;</div>
              {categoryName?.replace(/-/g, " ").toUpperCase()}
            </div>
          </div>
          <div className="font-poppins 2xl:hidden text-white xl:text-[14px] font-light flex xl:px-[64px] font-regular text-[10px] lg:text-[12px] lg:pt-[24px] pt-[12px] xs:px-[32px] px-[16px]">
            <a href={"/"}><span className="mr-[7px]">Category</span></a>
            <div className="mr-[7px] mt-[0px]">&gt;</div>
            {categoryName?.replace(/-/g, " ").toUpperCase()}
          </div>
          <div className="flex flex-col w-full items-center justify-center">
            <h1 className="uppercase text-white font-poppins font-regular text-[32px] xs:text-[38px] lg:text-[64px]">
              {categoryName?.replace(/-/g, " ")}
            </h1>
          </div>
        </div>
      </div>

      <div ref={itemsContainerRef} className="absolute h-[30px] w-full top-[275px] xs:top-[680px] lg:top-[240px] xl:top-[260px]"></div>

      <div className="w-full 2xl:max-w-[1440px] xs:flex-row-reverse gap-[16px] xs:justify-between xs:px-[32px] xs:items-start sp:mt-[16px] xs:mt-[24px] 2xl:px-[32px] flex flex-col 2xl:mx-auto">
        
        <div className="w-full max-w-[355px] lg:max-w-[355px] xl:max-w-[404px] flex flex-col mx-auto xs:max-w-[320px]">
          <div className="w-full bg-white items-center mx-auto flex pt-[16px] pb-[10px] sp:rounded-[4px] flex-col px-[16px] gap-[15px] xs:bg-white xs:rounded-[4px] xl:max-w-[404px] lg:max-w-[355px] ">
            <div className="flex flex-row xs:max-w-[500px] w-full items-center justify-between">
              <span className="font-noto text-[14px] xl:text-[16px] font-regular">Rating</span>
              <div className="w-[193px] lg:w-[250px] flex flex-row rounded-[5px] xl:h-[40px] h-[30px] border-opacity-20 border border-[0.5px] border-[#1A1A1A]">
                <div onClick={() => handleFilterChange(selectedCountry, 0)} className={`border-r cursor-pointer w-full border-r-[0.5px] border-r-[#1A1A1A] border-opacity-20 flex items-center justify-center ${minRating === 0 ? 'bg-[#1E7D6B] bg-opacity-90 rounded-l-[4px] text-white' : ''}`}>
                  <p className="font-noto font-regular text-[10px] xl:text-[12px]">Any</p>
                </div>
                {[3.0, 4.0, 4.5].map(v => (
                  <div key={v} onClick={() => handleFilterChange(selectedCountry, v)} className={`border-r w-full cursor-pointer border-r-[0.5px] border-opacity-20 border-r-[#1A1A1A] flex flex-row items-center justify-center gap-[3px] ${minRating === v ? 'bg-[#1E7D6B] bg-opacity-90 text-white' : ''}`}>
                    <img className={`w-[12px] ${minRating === v ? 'invert' : ''}`} src={starofcat} alt="" />
                    <p className="font-noto font-regular text-[10px] xl:text-[12px] mt-[1px]">{v.toFixed(1)}+</p>
                  </div>
                  ))}
                </div>
            </div>

            <div className="flex flex-row xs:max-w-[500px] items-center w-full justify-between">
              <span className="font-noto text-[14px] xl:text-[16px] font-regular">Location</span>
              <select value={selectedCountry} onChange={(e) => handleFilterChange(e.target.value, minRating)} className="w-[193px] h-[30px] lg:w-[250px] text-[#1a1a1a] xl:h-[40px] text-[10px] xl:text-[12px] font-noto font-regular appearance-none bg-white border border-black border-opacity-20 px-[15px] rounded leading-tight focus:outline-none">
                {countries.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>
            <span className="text-[#1a1a1a] mt-[5px] font-noto font-regular text-[12px] lg:text-[14px] xl:text-[16px] xs:pb-[10px] xs:mt-[10px]">
              Showing {(currentPage - 1) * itemsPerPage + 1}-{Math.min(currentPage * itemsPerPage, totalServerCount)} of {totalServerCount} results
            </span>
          </div>

          <div className="xs:flex flex-col mt-[16px] xl:mt-[24px] 2xl:mt-[32px] py-[13px] gap-[20px] px-[14px] w-full bg-white rounded-[4px] hidden">
            <span className="font-noto font-medium text-[12px] text-[#1a1a1a] lg:text-[14px] xl:text-[16px] text-center mx-auto max-w-[204px]">How do I know I can trust these Testimonials?</span>
            <div className="flex flex-row gap-[26px] justify-between">
              <img src={finalcheck} alt="" />
              <p className="text-[12px] font-noto text-[#1a1a1a] xl:text-[14px]">Suspicious testimonials are identified by our moderators and our active community members.</p>
            </div>
            <div className="flex flex-row gap-[26px] mt-[12px] justify-between">
              <img src={finalcheck} alt="" />
              <p className="text-[12px] font-noto text-[#1a1a1a] xl:text-[14px]">A verified user badge confirms that the individual providing the testimonial has successfully completed our identity verification process.</p>
            </div>
          </div>
        </div>

        <div className="flex lg:flex-col items-center xs:items-start xs:pr-[24px] flex-col gap-[20px] w-full bg-[#f3f3f3] xs:pt-0 pt-[10px] pb-[20px] lg:flex-row">
          <div className="flex flex-col gap-[20px] w-full">
            <div className="flex flex-col xl:items-end gap-[16px] xl:gap-[24px] 2xl:gap-[32px] w-full xs:pt-0">
              {loading ? (
                 <div className="w-full text-center py-10 font-noto opacity-50 italic">Sorting Top Results...</div>
              ) : FilteredItems.length > 0 ? (
                FilteredItems.map((company, index) => (
                  <Company
                    key={index}
                    title={company.title}
                    img={company.img || (company.www ? `https://cdn.brandfetch.io/${company.www}/w/200/h/200/fallback/404` : null)}
                    stars={company.trustscore}
                    reviews={company.reviews}
                    trustscore={company.trustscore}
                    cat={company.cat}
                    category={company.category}
                    country={company.country}
                    www={company.www}
                  />
                ))
              ) : (
                <p className="font-noto text-center w-full py-10 bg-white rounded">No companies found in this category.</p>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="w-[100%] xs:mt-[60px] mb-[40px] mx-auto ip:mt-[20px] lg:max-w-[650px] lg:h-[50px] ip:max-w-[400px] flex bg-white h-[40px] rounded-[5px]">
        <div className="flex items-center w-full max-w-[110px] justify-center border-[#F3F3F3] border-r-[4px] flex-grow cursor-pointer" onClick={() => handleSetPage(currentPage - 1)}>
          <span className="font-staat text-[16px] text-[#1C6065] text-center font-regular">Previous</span>
        </div>
        <div className={`flex items-center w-full max-w-[70px] justify-center border-[#F3F3F3] border-r-[4px] flex-grow cursor-pointer ${currentPage === 1 ? 'font-bold' : ''}`} onClick={() => handleSetPage(1)}>
          <span className="font-staat text-[#1C6065] text-[16px]">1</span>
        </div>
        {currentPage > 4 && (
          <div className="flex items-center w-full max-w-[70px] justify-center border-[#F3F3F3] border-r-[4px] flex-grow">
            <span className="font-staat text-[#1C6065] text-[16px]">...</span>
          </div>
        )}
        {[...Array(totalLoopPages)].map((_, i) => i + 1)
          .filter(page => (page >= currentPage - 1 && page <= currentPage + 1) || (currentPage <= 3 && page <= 4) || (currentPage >= totalLoopPages - 2 && page >= totalLoopPages - 3))
          .filter(page => page > 1 && page < totalLoopPages)
          .map(page => (
            <div key={page} className={`flex items-center w-full max-w-[70px] justify-center border-[#F3F3F3] border-r-[4px] flex-grow cursor-pointer ${currentPage === page ? 'font-bold' : ''}`} onClick={() => handleSetPage(page)}>
              <span className="font-staat text-[#1C6065] text-[16px]">{page}</span>
            </div>
          ))}
        {currentPage < totalLoopPages - 3 && (
          <div className="flex items-center justify-center w-full max-w-[70px] border-[#F3F3F3] border-r-[4px] flex-grow">
            <span className="font-staat text-[#1C6065] text-[16px]">...</span>
          </div>
        )}
        {totalLoopPages > 1 && (
          <div className={`flex items-center w-full max-w-[70px] justify-center border-[#F3F3F3] border-r-[4px] flex-grow cursor-pointer ${currentPage === totalLoopPages ? 'font-bold' : ''}`} onClick={() => handleSetPage(totalLoopPages)}>
            <span className="font-staat text-[#1C6065] text-[16px]">{totalLoopPages}</span>
          </div>
        )}
        <div className="flex items-center border-[#F3F3F3] justify-center border-l-0 font-staat text-[16px] text-[#1C6065] w-full max-w-[110px] text-center font-regular flex-grow cursor-pointer" onClick={() => handleSetPage(currentPage + 1)}>
          <span>Next</span>
        </div>
      </div>
    </div>
  );
}

export default CategoriesPage;